module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-delete-conf"
  }, [_c('button', {
    staticClass: "button small warning fa fa-times",
    on: {
      "click": _vm.deleteConf
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3029ce1f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/DeleteConf.vue
// module id = 2381
// module chunks = 1